<template>
  <div class="property_wrap">
    <div class="pro_top">轮播图设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
        <el-form-item label="图片编辑:">
          <el-upload
              :action="uploadImg"
              :data="data_"
              list-type="picture-card"
              :limit="9"
              :file-list="fileList"
              :on-success="handleSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :before-upload="beforeAvatarUpload">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          <p class="infodescribe">图片大小不超过1M,支持jpg、png格式，最多可上传9张</p>
          <p class="infodescribe">建议所有轮播图比例一致，轮播效果更佳</p>
          <!--<div style="display: none">-->
            <!--<uploadImg :picimg="form.pic" @getChildValue="getChildValue" imgNumber="10"></uploadImg>-->
          <!--</div>-->
          <!--<div>-->
            <!--<draggable v-model="form.pic" :options="{draggable:'.draggableItem',animation: 150}" :move="getdata"-->
                       <!--@update="datadragEnd" class="draggable-body-list">-->
              <!--<transition-group class="draggable-body">-->
                <!--<div v-for="(item,index) in form.pic" :key="item" class="draggableItem" :draggable="draggable"-->
                     <!--:style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"-->
                     <!--:class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">-->
                  <!--<i class="el-icon-circle-close" @click="detelFn(index)"></i>-->
                <!--</div>-->
              <!--</transition-group>-->
            <!--</draggable>-->
          <!--</div>-->
          <!--<div class="pro_con">-->
            <!--<div class="img_body" @click="showCropper">-->
              <!--<p class="img_up_text">点击上传</p>-->
            <!--</div>-->
            <!--<p class="prompInfo">第一张默认为封面,可以拖拽图片调整顺序，最多上传9张，尺寸750*1048比例，大小在2M以内</p>-->
            <!--&lt;!&ndash;end&ndash;&gt;-->
          <!--</div>-->
        </el-form-item>
      </el-form>
    </div>
    <!--<corpper :visible.sync="corppervisible" v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>-->
  </div>
</template>
<script>
  import corpper from "@/components/dialog/corpper.vue";
  import draggable from 'vuedraggable';
  import api from "@/api.js"
  import uploadImg from "@/components/dialog/uploadImg.vue";
  export default {
    props: ["property"],
    components: {
      corpper,
      draggable,
      uploadImg
    },
    data() {
      return {
        // corpper
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        imgSize: 2,
        corppervisible: false,
        currentindex:0,
        // end
        dialogImageUrl: '',
        dialogVisible: false,
        fileList:[],
        form: {
          pic: []
        }
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          let fileList = []
          for(let i in val.pic){
            let fileList_line = {};
            fileList_line.name = i;
            fileList_line.url = val.pic[i];
            fileList.push(fileList_line)
          }
          this.fileList = fileList
          this.form = val
        }
      }
    },
    created(){
      if(this.property.pic.length!==0){
        let fileList = []
        for(let i in this.property.pic){
          let fileList_line = {};
          fileList_line.name = i;
          fileList_line.url = this.property.pic[i];
          fileList.push(fileList_line)
        }
        this.fileList = fileList
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      handleRemove(file, fileList) {
        let pic = [];
        for (let i in  fileList) {
          if(fileList[i].response){
            pic.push(fileList[i].response.path)
          }else{
            pic.push(fileList[i].url);
          };
        };
        this.form.pic = pic;
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleSuccess(response, file, fileList) {
        if (response.code === 0) {
          let pic = [];
          for (let i in  fileList) {
            if(fileList[i].response){
              pic.push(fileList[i].response.path)
            }else{
              pic.push(fileList[i].url);
            };
          };
          this.form.pic = pic;
          this.fileList = fileList;
        } else {
          this.$message.error(res.msg);
        }
        this.loadingStatus.close();
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;

        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 1MB!');
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        return isLt2M;
      },
      // 裁切
      detelFn(index){
        this.form.pic.splice(index, 1)
      },
      indexLine(index) {
        this.currentindex = index
      },
      datadragEnd(evt) {
        this.currentindex = evt.newIndex
      },
      getdata(data) {
      },
      imgAddBack(option) {
        if(this.form.pic.length<9){
          this.form.pic.push(option)
        }else{
          this.$message({
            message: '组件最多9张图',
            type: 'warning'
          });
        }
      },
      showCropper() {
        this.corppervisible = true
      },
      uploadalbum(val) {
        this.form.pic = val;
      },
      getChildValue(option){
        this.form.pic = option
      }
    }
  };
</script>

